import styled from '../../../styles/theme';
import { FAQsStyled } from '../FAQsStyled';
import { rem } from 'polished';

export const FAQsStyledDS = styled(FAQsStyled)`
    border: 0;
    padding-top: ${rem(45)};
`;
